import { Configuration } from "@freightsimple/generated-dashboard-openapi-client/runtime";
import { SavedCommoditiesApi } from "@freightsimple/generated-dashboard-openapi-client/apis/SavedCommoditiesApi";
import { useAuthentication } from "@/Slices/authenticationSlice";
import { getConfig } from "@/Apis/getConfig";

export function useSavedCommoditiesApi(): SavedCommoditiesApi {
  const { accessToken } = useAuthentication();

  return new SavedCommoditiesApi(
    new Configuration({ ...getConfig(), accessToken: accessToken }),
  );
}
